import { IDisneyValidateOtpRequest, IDisneyValidateOtpResponse } from '../../../../lib/entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IDisneyValidateOtpUseCase {
    execute(
        params: IDisneyValidateOtpRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IDisneyValidateOtpResponse>;
}

export class DisneyValidateOtpUseCase implements IDisneyValidateOtpUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(
        params: IDisneyValidateOtpRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IDisneyValidateOtpResponse> {
        return await this.subscriptionRepository.disneyValidateOtp(params, apiToken);
    }
}
